module.exports = __webpack_public_path__ + "img/arrow-up-left.d37c6941.svg";